/* Dansk katalog for locale-journal-recovery-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('da', {
  'journalRecovery.title': 'Regnskabet er midlertidigt utilgængeligt',
  'journalRecovery.description': 'Journalen kunne ikke kontrolleres. Regnskabssider og ændringer er spærret, indtil kontrollen lykkes. Du kan kontakte support eller skifte virksomhed i menuen.',
  'journalRecovery.reference': 'Virksomhed: {businessId} · Regnskabsår: {year}',
  'journalRecovery.retry': 'Prøv igen',
  'journalRecovery.retrying': 'Kontrollerer …',
  'journalRecovery.support': 'Kontakt support',
  'journalRecovery.signOut': 'Log ud',
  'journalRecovery.writeBlocked': 'Journalgrundlaget er utilgængeligt. Prøv igen, før du ændrer regnskabet.',
});
